export default "__VITE_ASSET__BBdCpSXM__"